///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createAction, props } from '@ngrx/store';
import { SystemInfoDTO } from '../../../generated/shared-types.model';

export const getSystemInfo = createAction('[SystemInfo] Get System Info');
export const setSystemInfo = createAction('[SystemInfo] Set System Info', props<{ systemInfo: SystemInfoDTO }>());
